<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.3028 15.2917H0.5V6.41307H4.09154C5.09632 6.41307 6.18477 4.06361 6.41801 1.49344L6.4704 0.916748H7.04927C8.20406 0.916748 8.81758 0.986932 9.49828 1.32686C10.5069 1.83252 11.0633 2.81932 11.0633 4.2991V5.56748H13.176C13.882 5.56747 14.5497 5.88856 14.9907 6.44014C15.4317 6.99172 15.5983 7.71399 15.4433 8.40316L14.3025 13.4767C14.0639 14.5378 13.1222 15.2918 12.0352 15.2917H4.3028ZM4.30274 14.0234H12.0351C12.5291 14.0234 12.9572 13.6808 13.0657 13.1985L14.2065 8.12497C14.277 7.81169 14.2013 7.48335 14.0008 7.23259C13.8004 6.98184 13.4969 6.83586 13.176 6.83587H9.79568V4.2991C9.79568 2.72335 9.20583 2.27138 7.61456 2.19697C7.23809 5.02884 6.03133 7.48443 4.30274 7.67004V14.0234ZM1.7676 14.0234V7.68145H3.0352V14.0234H1.7676Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class LikeIcon extends Vue {}
</script>
